import type { ComponentProps } from "react"
import { cn } from "~/lib/utils"

export function IssuePropertyIcon({
	label,
	withText,
	color,
	className,
	style,
	children,
	...props
}: ComponentProps<"svg"> & { label: string; withText?: boolean }) {
	const icon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
			role={withText ? undefined : "img"}
			aria-label={withText ? undefined : label}
			aria-hidden={withText || undefined}
			className={cn("shrink-0", className)}
			style={{ color, ...style }}
			{...props}
		>
			{children}
		</svg>
	)

	return withText ? (
		<div className="flex items-center gap-1.5">
			{icon}
			<span>{label}</span>
		</div>
	) : (
		icon
	)
}
